import { Injectable, InjectionToken, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders,
  HttpBackend,
  HttpClient
} from '@angular/common/http';
import { Observable, throwError, of, iif, defer, EMPTY } from 'rxjs';
import { tap, catchError, map, switchMap, startWith } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { LOGIN_URL } from './tokens';
import { IdentityStore } from './identity-store';
import { identityConstants } from './identity-constants';
import { jwtDecode } from './jwt-decode';
import { RefreshTokenResultModel } from './definition/refresh-token-result.model';
import { ExpiredTokenHandler } from './expired-token-handler';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {


  constructor(
    private router: Router,
    @Inject(LOGIN_URL) private loginUrl: string,
    private httpBackend: HttpBackend,
    private activatedRoute: ActivatedRoute,
    private expiredTokenHandler: ExpiredTokenHandler,
    private store: IdentityStore) {

  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let defer$ = defer(() => {
      if (this.store.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.store.token}`
          }
        })
      }
      return next.handle(request).pipe(
        tap(res => {
          if (res instanceof HttpResponse) {
            token = res.headers.get(identityConstants.token)
            if (token) {
              this.store.token = token;
              // localStorage.setItem('token', token);
            }
          }
        }),
        catchError((err, caught) => this.handleError(err))
      );
    })
    let token = this.store.token;
    let refreshToken = this.store.refreshToken;
    let expired = false;

    if (!token) {
      expired = true;

    }
    else {
      const jwt = jwtDecode(token);
      var exp = (jwt.exp as number) * 1000;
      var now = new Date().getTime();
      if (now >= exp) {
        expired = true;
      }
    }
    if (expired && refreshToken) {
      const httpClient = new HttpClient(this.httpBackend);
      return httpClient.get<RefreshTokenResultModel>(`${identityConstants.identityApiRoute}/refreshToken`, {
        headers: {
          Authorization: `Bearer ${refreshToken}`
        }
      }).pipe(
        catchError(err => {
          this.store.clear();
          return of(<RefreshTokenResultModel>undefined)
        }),
        tap(p => {
          if (p) {
            this.store.token = p.token;
            this.store.refreshToken = p.refreshToken;
            this.store.permissions = p.permissions;
          }
          // else {
          //   this.store.clear();
          // }

        }),
        switchMap(() => defer$)
      )
    }
    else {
      return defer$;
    }
  }

  handleError(err: any) {
    if (err instanceof HttpErrorResponse && err.status == 401) {
      // this.store.clear();
      // debugger;
      this.expiredTokenHandler.handle(this.loginUrl);
      // if (!this.activatedRoute.snapshot.queryParams["redirectUrl"]) {
      //   this.router.navigateByUrl(`${this.loginUrl}?redirectUrl=${encodeURIComponent(window.location.href)}`);
      // }
      return EMPTY;
    }
    return throwError(err);
  }
}
